module.exports = __webpack_public_path__ + "media/images/assignments-placeholder-d4104dabe39aa402d21c920b9ec1ba1a.png";